import styled from "styled-components";
export const Label = styled.label `
  font-size: ${({ theme, type }) => type === "checkbox"
    ? theme.fontTokens.font12[0]
    : theme.fontTokens.font14[0]};
  line-height: ${({ theme, type }) => type === "checkbox"
    ? theme.fontTokens.font12[1]
    : theme.fontTokens.font14[1]};
  color: ${({ theme }) => theme.colors.grey13};

  ${({ hasError, theme }) => hasError
    ? `
    /* overwrite html5 label-to-input hover state */
    &:hover ~ div {
      input:hover,
      textarea:hover {
        border: 1px solid ${theme.colors.grey10};
        background-color: ${theme.colors.white};
      }
      input:active,
      input:focus,
      textarea:active,
      textarea:focus {
        background-color: ${theme.colors.offWhite};
        border: 1px solid ${theme.colors.grey14};
      }
      input:read-only,
      textarea:read-only {
        cursor: default;
        background-color: ${theme.colors.grey04};
        border: 1px solid rgba(${theme.colors.transparentBlack}, 0);
      }
      input:disabled,
      textarea:disabled {
        background-color: ${theme.colors.grey03};
        border: 1px solid rgba(${theme.colors.transparentBlack}, 0);
        color: rgba(${theme.colors.transparentBlack}, 0.26);
      }
    }
  `
    : ""}

  ${({ isToggle, theme, type, disabledStates, isFlyout, hasError, checked, groupSelection, }) => isToggle
    ? `
        color: ${theme.colors.grey15};
        display: flex;
        align-items: center;
        cursor: pointer;
        min-height: 1.25rem;
        margin: 0 0 0 ${isFlyout ? "2.5rem" : `2.75rem`};
    
        &:hover {
          ${!disabledStates
        ? `
              &:before {
                border: 1px solid rgba(${theme.colors.transparentBlack}, 0);
                background-color: rgba(${theme.colors.transparentBlack}, 0.08);
              }`
        : ""}

          &:after {
            background-color: rgba(${theme.colors.transparentBlack}, 0);
            border: 1px solid ${hasError && !checked
        ? theme.colors.error
        : checked
            ? theme.colors.grey15
            : theme.colors.black};
          }
        }

        &:active {
          ${!disabledStates
        ? `
              &:before {
                background-color: ${theme.colors.grey15};
                border: 1px solid ${theme.colors.grey15};
              }

              &:after {
                border: 1px solid ${theme.colors.grey10};
                background: transparent;
              }

              span {
                svg, svg path {
                  fill: ${theme.colors.grey10};
                }
                color: ${theme.colors.grey10};
                ${type === "radio"
            ? `border: 1px solid ${theme.colors.grey10}; 
                    background-color: ${theme.colors.grey10};`
            : ""}
              }`
        : ""}
        }

        &:after {
          content: '';
          display: block;
          position: absolute;
          ${hasError && !checked
        ? `border: 1px solid ${theme.colors.error};`
        : checked || groupSelection
            ? `border: 1px solid ${theme.colors.grey15};`
            : `border: 1px solid ${theme.colors.grey10};`}
          ${type === "radio" ? "border-radius: 50%;" : ""};
          background: ${theme.colors.white};
          height: 1.375rem;
          width: 1.375rem;
          left: 0.5rem;
          top: 50%;
          transform: translateY(-50%);
        }

        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          min-width: 2.5rem;
          min-height: 2.5rem;
          box-sizing: border-box;
          border: 1px solid rgb(${theme.colors.transparentBlack}, 0);
          ${type === "radio" ? "border-radius: 50%;" : ""};
        }

        & > span {
          display: none;
          position: absolute;
          z-index: 1;
          ${type === "radio"
        ? `border: 1px solid ${theme.colors.black}; 
                border-radius: 50%; 
                width: 0.5rem; 
                height: 0.5rem; 
                top: 0.9375rem;
                left: 0.9375rem;
                background-color: ${theme.colors.black};`
        : "top: 0.75rem;left: 0.75rem;"}
        }`
    : ""};
`;
